import { render, staticRenderFns } from "./AssetFrequencySettings.vue?vue&type=template&id=9c31d916"
import script from "./AssetFrequencySettings.vue?vue&type=script&lang=js"
export * from "./AssetFrequencySettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports